export const csatFeatures = {
  createInvoice: 'createInvoice',
  uploadDocument: 'uploadDocument',
  setDocumentFilter: 'setDocumentFilter',
  analyzeDocument: 'analyzeDocument',
  manageFolders: 'manageFolders',
  searchDocuments: 'searchDocuments',
}

export const csatFeaturesMapping: { [key: string]: string } = {
  createInvoice: 'buchhaltung_do-4857',
  uploadDocument: 'document_do-4749',
  setDocumentFilter: 'document_do-4750',
  analyzeDocument: 'document_do-4751',
  manageFolders: 'document_do-4752',
  searchDocuments: 'document_do-4753',
}

type CsatMappingValue = { amount: number; unit: 'day' | 'month' | 'year' } | null

export const csatShowAgainMapping = new Map<string, CsatMappingValue>([
  [csatFeatures.analyzeDocument, null],
  [csatFeatures.createInvoice, null],
  [csatFeatures.manageFolders, null],
  [csatFeatures.setDocumentFilter, null],
  [csatFeatures.uploadDocument, null],
  [csatFeatures.searchDocuments, { amount: 90, unit: 'day' }],
])
